import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { Button } from 'react-bootstrap';
import useFetchUserInsightsContent from 'App/hooks/useFetchUserInsightsContent';
import TherigyLoadingSpinner from 'App/components/TherigyLoadingSpinner';
import useFetchTherigyInsightsContent from 'App/hooks/useFetchTherigyInsightsContent';
import * as R from 'ramda';
import { getExplore } from 'App/services/ReportEngineService';
import { queryClient } from 'Shared/queryClient';
import { useUserContext } from 'App/contexts/UserContext';
import GroupList from '../GroupList';
import TherigyDashboardList from '../TherigyDashboardList';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import { FaPlus } from 'react-icons/fa';

const propTypes = {};

const defaultProps = {};

const SidebarStyle = styled('div')`
    width: 266px;
    padding: 1.25rem 0 1.25rem 1.25rem;

    .button-list {
        padding-left: 1.875rem;

        li {
            button {
                vertical-align: top;
            }
        }
    }

    button.btn.btn-link {
        display: inline;
        padding: 2.5px 0;
        white-space: normal;
        text-align: left;
    }

    .group-list {
        padding-left: 1rem;
    }

    .sidebar-group {
        button {
            background: transparent;
            padding: 0;
            margin: 0;
            font-size: 1rem;
            border: none;
        }

        h4,
        h5 {
            text-align: left;
        }
    }
`;

function loadExplore() {
    return getExplore('explore_base', 'Insights_Explore').then((result) => {
        queryClient.setQueryData(['insights', 'embedUrl'], result);
    });
}

function Sidebar() {
    const user = useUserContext();

    const isReportBuilder = useIsPermitted(PERMISSION_TYPES.REPORT_BUILDER);

    const companyName = useMemo(() => {
        if (user?.CompanyName) {
            return user.CompanyName;
        }
        return '';
    }, [user]);

    const therigyContent = useFetchTherigyInsightsContent();
    const userContent = useFetchUserInsightsContent();

    if (userContent.isLoading || therigyContent.isLoading) {
        return <TherigyLoadingSpinner />;
    }

    return (
        <SidebarStyle>
            {isReportBuilder ? (
                <Button
                    variant="link"
                    onClick={loadExplore}
                    style={{ paddingTop: '0.625rem', paddingBottom: '1.25rem' }}
                >
                    <FaPlus /> Create Custom Report
                </Button>
            ) : null}

            <TherigyDashboardList dashboardGroups={R.values(therigyContent.data || [])} />

            <GroupList
                groupName={companyName}
                dashboards={userContent.data?.companyDashboards || []}
                looks={userContent.data?.companyLooks || []}
            />

            <GroupList
                groupName="Your"
                dashboards={userContent.data?.userDashboards || []}
                looks={userContent.data?.userLooks || []}
            />
        </SidebarStyle>
    );
}

Sidebar.propTypes = propTypes;
Sidebar.defaultProps = defaultProps;

export default Sidebar;
